<template>
  <div class="indexbox">
    <div class="bgfff flex px20 h46 mt20">
      <img src="@/assets/index/notice.png" class="noticeicon" alt="">
      <div class="flex1 ml20">
        <noticeScroll>
          {{ notiContent }}
        </noticeScroll>
      </div>
    </div>
    <div class="bgfff flex px20 h46 mt20">
      <img src="@/assets/index/searchicon.png" class="seicon" alt="">
      <div class="flex1 ml20 flex-between">

        <el-input placeholder="请输入您要搜索的关键词" @keyup.enter.native="handleSearch" @blur="handleSearch" v-model="search"
          size="small"></el-input>
        <div class="searchbtn" @click="handleSearch">搜索</div>
      </div>
    </div>
    <div class="menubox  bgfff">
      <!-- 材料分类 -->
      <div class="flex yige">
        <div class="fs18 fw400 typetit">材料分类</div>
        <div class="flex classline">
          <div @click="changeMenu(item, index)" v-for="(item, index) in typeList" :key="item.id"
            :class="typeCurrent == index ? 'activemenu' : ''" class="point menuone">
            <!-- :style="{ width: 100 / typeList.length + '%' }" -->
            {{ item.title }}
          </div>
        </div>
      </div>
      <!-- 材料状态 -->
      <div class="flex yige">
        <div class="fs18 fw400 typetit">材料状态</div>
        <div class="flex classline">
          <div @click="changeMetType(item, index)" v-for="(item, index) in metType" :key="item.id"
            :class="metTypeIndex == index ? 'activemenu' : ''" class="point menuone">
            <!-- :style="{ width: 100 / typeList.length + '%' }" -->
            {{ item.title }}
          </div>
        </div>
      </div>
      <!-- 单价范围 -->
      <div class="flex yige" style="align-items: center;">
        <div class="fs18 fw400 typetit fwtitle">材料单价范围</div>
        <div class="flex classline">
          <div @click="new_product_price_minimum = ''; new_product_price_highest = ''; getMaterialList()"
            class="point menuone">
            <!-- :class="new_product_price_minimum == '' && new_product_price_highest == '' ? 'activemenu' : ''" -->
            不限
          </div>
          <div class="flex">
            <div class="iptbox">
              <el-input @blur="blurPrice(new_product_price_minimum)" placeholder="最低"
                v-model="new_product_price_minimum" type="number" size="small"></el-input>
            </div>
            <div class="iline"></div>
            <div class="iptbox">
              <el-input @blur="blurPrice(new_product_price_highest)" placeholder="最高"
                v-model="new_product_price_highest" type="number" size="small"></el-input>
            </div>
          </div>
        </div>
      </div>
      <!-- 原价范围 -->
      <div class="flex yige" style="align-items: center;">
        <div class="fs18 fw400 typetit fwtitle">新品单价范围</div>
        <div class="flex classline">
          <div @click="selling_price_minimum = ''; selling_price_highest = ''; getMaterialList()" class="point menuone">
            <!-- :class="selling_price_minimum == '' && selling_price_highest == '' ? 'activemenu' : ''" -->
            不限
          </div>
          <div class="flex">
            <div class="iptbox">
              <el-input @blur="blurPrice(selling_price_minimum)" placeholder="最低" v-model="selling_price_minimum"
                type="number" size="small"></el-input>
            </div>
            <div class="iline"></div>
            <div class="iptbox">
              <el-input @blur="blurPrice(selling_price_highest)" placeholder="最高" v-model="selling_price_highest"
                type="number" size="small"></el-input>
            </div>
          </div>
        </div>
      </div>


    </div>
    <!-- 材料列表 -->
    <!-- <div class="fs18 fw500 m20">{{ typeList[typeCurrent].title }}</div> -->
    <template v-if="!materialList.length">
      <empty description="暂无材料"></empty>
    </template>
    <div v-else>
      <div v-for="item in materialList" :key="item.id" class="bgfff radius5 p20 flex-between mt20 meterialone">
        <div class="flex fs16 mr57">
          <img class="climg radius5" :src="item.material_images" alt="">
          <div class="">
            <div class="fs18 fw500 mb10">{{ item.material_name }}</div>
            <div class="mb10">材料型号: {{ item.material_model }}</div>
            <div class="color777 mb10 line2">{{ item.usage_instructions }}</div>
            <div class="flex fs18">
              <!-- <div>材料售价: <span class="colorff3737"> ¥{{ item.selling_price }}</span></div> -->
              <div class="mr52">材料单价: <span class="colorff3737"> ¥{{ item.selling_price }}</span></div>
              <div class="mr52">新品单价: <span class="colorff3737"> ¥{{ item.new_product_price }}</span></div>
              <div class="mr52">材料状态: <span class="colorff3737"> {{ item.material_type_title }}</span></div>
              <div>数量: <span class="colorff3737"> {{ item.material_quantity }}</span></div>
            </div>
          </div>
        </div>
        <div class="btndiv">
          <el-button @click="goMeterialDetail(item)" type="success" size="mini" class="lookbtn">查看详情</el-button>
          <div @click="isShow = true" class="point mt10 fs16" style="color: #218FFE;">联系客服</div>
        </div>
      </div>
    </div>
    <pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :total="total"
      :pageSize="pagesize" :currentPage="page"></pagination>
    <kefuFixed @changeShow="changeShow" :isShow="isShow" :showOut="false"></kefuFixed>
  </div>
</template>
<script>
import noticeScroll from "@/components/noticeScroll/noticeScroll.vue"
import pagination from '@/components/pagination/pagination.vue';
import kefuFixed from '@/components/kefuFixed/kefuFixed.vue';
import empty from '@/components/empty/empty.vue';



export default {
  components: { pagination, kefuFixed, empty, noticeScroll },

  data() {
    return {
      isShow: false,
      materialList: [],
      typeCurrent: 0,
      typeList: [],
      notiContent: '',
      total: 0,
      page: 1,
      pagesize: 10,
      search: '',
      // 材料状态
      metType: [
        { id: '', title: '全部' },
        { id: '1', title: '已报废' },
        { id: '2', title: '旧品翻新' },
        { id: '3', title: '全新' },
        { id: '4', title: '盲盒' },
      ],
      metTypeIndex: 0,
      new_product_price_minimum: '',
      new_product_price_highest: '',
      selling_price_minimum: '',
      selling_price_highest: ''
    };
  },
  async mounted() {
    await this.getNotice();
    await this.getTypeList();
    await this.getMaterialList();
    // if(this.$route.query.search){
    //   this.search = this.$route.query.search
    //   this.page=1
    //   this.typeCurrent=0
    //   this.getMaterialList()
    // }
  },
  // watch: {
  //   '$route.query.search': function (val) {
  //     this.search = val
  //     this.page = 1
  //     this.typeCurrent = 0
  //     this.getMaterialList()
  //   }
  // },

  methods: {
    blurPrice(e) {
      console.log(e, "ee")
      if (e && Number(e) < 0) {
        this.$messge({
          message: '请输入大于0的数字',
          type: 'error'
          , duration: 2000
          , offset: 100
        })
      } else {
        this.page = 1
        this.getMaterialList()
      }
    },
    async getMaterialList() {
      let data = {
        page: this.page,
        pagesize: this.pagesize,
        material_classification_id: this.typeList[this.typeCurrent].id,
        search: this.search,
        material_type: this.metType[this.metTypeIndex].id,
        new_product_price_minimum: this.new_product_price_minimum,
        new_product_price_highest: this.new_product_price_highest,
        selling_price_minimum: this.selling_price_minimum,
        selling_price_highest: this.selling_price_highest
      }
      let res = await this.$http.post('/api/index/material_list', data)
      if (res.code == 1) {
        this.materialList = res.data.data;
        this.total = res.data.total;
      }


    },
    async getTypeList() {
      let res = await this.$http.post('/api/index/material_classification')
      if (res.code == 1) {
        let list = res.data
        list.unshift({
          id: '',
          title: '全部'
        })
        this.typeList = list;
      }

    },

    // 获取公告
    async getNotice() {
      let res = await this.$http.post('/api/index/announcement')
      console.log(res, "res")
      this.notiContent = res.data.map(item => item.content)[0]
    },
    changeShow(boo) {
      this.isShow = boo
    },
    changeMetType(item, index) {
      this.metTypeIndex = index
      this.page = 1
      this.getMaterialList()
    },
    handleSearch() {
      this.page = 1
      this.getMaterialList()
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getMaterialList();

    },
    handleCurrentChange(val) {
      this.page = val;
      this.getMaterialList();
    },

    goMeterialDetail(item) {
      this.$router.push(`/index/meterialDetail?id=${item.id}`)
    },
    changeMenu(item, index) {
      this.typeCurrent = index
      this.page = 1
      this.getMaterialList()
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-input__inner {
  border: none;
  outline: none;
  max-height: 40px;
  padding: 0 6px;
  font-size: 16px;
  background: transparent;
}

.searchbtn {
  width: 90px;
  height: 34px;
  background: #DCEDFF;
  border-radius: 5px;
  font-weight: 500;
  font-size: 16px;
  color: #218FFE;
  line-height: 34px;
  text-align: center;
  cursor: pointer;
}

.iptbox {
  width: 172px;
  height: 40px;
  background: #F6F8FA;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}

.iline {
  width: 30px;
  height: 2px;
  background: #E0E4E8;
  margin: 0 10px;
}

.seicon {
  width: 24px;
  height: 24px;
}

.indexbox {
  .noticeicon {
    width: 26px;
    height: 26px;
  }

  .meterialone {
    &:hover {
      transform: scale(1.05);
      transition: all .5s;
    }
  }

  .menubox {
    // height: 70px;
    background: #fff;
    font-size: 18px;
    margin-top: 24px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    .yige {
      align-items: flex-start;

    }

    .typetit {
      width: 120px;
      height: 70px;
      color: #798088;
      text-align: center;
      white-space: nowrap;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .classline {
      width: 100%;
      flex-wrap: wrap;

      .menuone {

        padding: 0 40px;
        // margin-bottom: 10px;

        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        text-align: center;
        height: 60px;
        line-height: 60px;
        color: #555;
        font-size: 18px;
        font-weight: 400;
        transition: all .3s;

        &:hover {
          // background-color: #E7F0F7;
          color: #218FFE;
        }
      }

      .activemenu {
        color: #218FFE;
        position: relative;
        font-weight: 600;

        &:after {
          content: '';
          position: absolute;
          bottom: 6px;
          left: 50%;
          transform: translateX(-50%);
          background: #218FFE;
          width: 30px;
          height: 4px;
          border-radius: 2px;
        }

      }
    }

  }

  .climg {
    width: 180px;
    height: 140px;
    min-width: 180px;
    margin-right: 18px;
  }

  .btndiv {
    width: 92px;
    text-align: center;
  }

  .lookbtn {
    background: #31CE06;
    font-size: 14px;
    text-align: center;
    height: 40px;
  }

  .fwtitle {
    width: 160px !important;
  }


}
</style>
